(function () {
  'use strict';

  $(document).ready(function () {

    const path = window.location.pathname || ''
    if (path !== '/' && path !== '/index.html' && !path.endsWith('passwort-anfordern.html') && !path.endsWith('konto-freischalten.html')) {
        return
    }

    // let loginValidator = $('#loginform').jbvalidator({
    //   errorMessage: true,
    //   successClass: true,
    //   language: "https://mein-hilo.de/i18n/validator/de.json"
    // })

    // Add validators
  //   let createPasswordValidator = $('#createPasswordForm').jbvalidator({
  //     errorMessage: true,
  //     successClass: true,
  //     language: "https://mein-hilo.de/i18n/validator/de.json"
      
  //   })
  //   let resetPasswordValidator = $('#resetPasswordForm').jbvalidator({
  //     errorMessage: true,
  //     successClass: true,
  //     language: "https://mein-hilo.de/i18n/validator/de.json"
  //   })

  //   let validator = $('form.needs-validation').jbvalidator({
  //     errorMessage: true,
  //     successClass: true,
  //     language: "https://emretulek.github.io/jbvalidator/dist/lang/en.json"
  // });

    handleTokenFields();
    handleResetPasswordFields();
    initPasswordToggle();

    let pendingMfaLogin = { username: null, mfaChallengeToken: null };

    const LOGIN_HEADLINE = 'Mitgliederportal';
    const LOGIN_SUBLINE = 'Geben sie ihre Login-Daten ein';
    const MFA_HEADLINE = 'Zwei-Faktor-Authentifizierung';
    const MFA_SUBLINE = 'Bitte geben Sie den Bestätigungscode aus Ihrer E-Mail ein.';

    function showLoginForm() {
      $('#loginHeadline').text(LOGIN_HEADLINE);
      $('#loginSubline').text(LOGIN_SUBLINE);
      $('#mfaform').addClass('hidden');
      $('#loginform').removeClass('hidden');
      pendingMfaLogin = { username: null, mfaChallengeToken: null };
      $('#mfaPin').val('');
      $('#mfaerror').addClass('hidden').empty();
    }

    function showMfaForm(username, mfaChallengeToken) {
      pendingMfaLogin.username = username;
      pendingMfaLogin.mfaChallengeToken = mfaChallengeToken;
      $('#loginHeadline').text(MFA_HEADLINE);
      $('#loginSubline').text(MFA_SUBLINE);
      $('#loginform').addClass('hidden');
      $('#mfaform').removeClass('hidden');
      $('#mfaPin').val('').focus();
      $('#mfaerror').addClass('hidden').empty();
    }

    // Login Form – Submit per Klick oder Enter
    $('#loginform').on('submit', function (e) {
        e.preventDefault();
        e.stopPropagation();
        Promise.resolve(login()).then(function (result) {
            if (result && result.mfaRequired) {
              showMfaForm(result.username, result.mfaChallengeToken);
              return;
            }
            window.location.href =  './secure/user/index.html'
        }).catch(function (err) {
          //console.log(err);
          let errorMessage = 'Ein Fehler ist aufgetreten';
          if (err.responseJSON && err.responseJSON.error) {
              errorMessage = err.responseJSON.error;
          } else if (typeof err === 'string') {
              errorMessage = err;
          } else if (err.message) {
              errorMessage = err.message;
          } else if (err.error) {
              errorMessage = err.error;
          }
          $('#lgerror').removeClass('hidden').html(errorMessage);
          setTimeout(function () {
            $('#lgerror').addClass('hidden');
          }, 5000);
        });
        return false;
    })

    $('#mfaform').on('submit', function (e) {
      e.preventDefault();
      e.stopPropagation();
      const pin = ($('#mfaPin').val() || '').trim();
      if (!pin) {
        $('#mfaerror').removeClass('hidden').html('Bitte geben Sie den Bestätigungscode ein.');
        return false;
      }
      $('#mfaSubmitButton').prop('disabled', true);
      Promise.resolve(loginMfa(pendingMfaLogin.username, pendingMfaLogin.mfaChallengeToken, pin))
        .then(function () {
          window.location.href = './secure/user/index.html';
        })
        .catch(function (err) {
          let errorMessage = 'Der Code ist ungültig oder abgelaufen. Bitte erneut anmelden.';
          if (err.responseJSON && err.responseJSON.error) {
            errorMessage = err.responseJSON.error;
          } else if (typeof err === 'string') {
            errorMessage = err;
          } else if (err.message) {
            errorMessage = err.message;
          } else if (err.error) {
            errorMessage = err.error;
          }
          $('#mfaerror').removeClass('hidden').html(errorMessage);
        })
        .finally(function () {
          $('#mfaSubmitButton').prop('disabled', false);
        });
      return false;
    });

    $('#mfaBackLink').on('click', function (e) {
      e.preventDefault();
      showLoginForm();
    });

    // Validate PIN Button
    $('#validatePinButton').on('click', function (e) {
      e.preventDefault()
      if (!$('#termsAccepted').is(':checked')) {
        $('#lgerror').removeClass('hidden').html('Bitte akzeptieren Sie die Nutzungsbedingungen.');
        setTimeout(function () { $('#lgerror').addClass('hidden'); }, 5000);
        return;
      }
      const pin = $('#pin').val();
      Promise.resolve(validatePin(pin))
        .then(function (result) {
          if (result.error !== undefined) {
            $('#lgerror').removeClass('hidden').html(result)
            setTimeout(function () {
              $('#lgerror').addClass('hidden');
            }, 5000);
            return
          }
          if (result.data.emailcheck === false) {
            $('#validatePinButton').hide();
            $('#createPasswordButton').show();
            $('#emailDiv').show();
            $('#email2Div').show();
            $('#termsDiv').hide();
            $('#createPasswordSubline1').hide();
            $('#createPasswordSubline2').show();
            $('#createPasswordSubline3').hide();
            $('#passwordHintDivCreatePassword').hide();
          } else {
            $('#validatePinButton').hide();
            $('#termsDiv').hide();
            $('#lgsuccess').removeClass('hidden').html('Die PIN wurde erfolgreich validiert, prüfen Sie Ihr Email-Postfach.')
            $('#createPasswordSubline1').hide();
            $('#createPasswordSubline2').hide();
            $('#createPasswordSubline3').hide();
            $('#passwordHintDivCreatePassword').hide();
          }
        }).catch(function (err) {
          //console.log(err);
          let errorMessage = 'Ein Fehler ist aufgetreten';
          if (err.responseJSON && err.responseJSON.error) {
            errorMessage = err.responseJSON.error;
          } else if (typeof err === 'string') {
            errorMessage = err;
          } else if (err.message) {
            errorMessage = err.message;
          } else if (err.error) {
            errorMessage = err.error;
          }
          $('#lgerror').removeClass('hidden').html(errorMessage);
          setTimeout(function () {
            $('#lgerror').addClass('hidden');
          }, 5000);
        })
    })
    // Reset Password Button
    $('#resetPasswordButton').on('click', function (e) {
      e.preventDefault()
      // const errorCount = resetPasswordValidator.checkAll();
      // if (errorCount > 0) {
      //   return false;
      // }
      const email = $('#email').val();
      Promise.resolve(resetPassword(email))
        .then(function (result) {
          $('#emailDiv').hide();
          $('#resetPasswordButton').hide();
          $('#lgsuccess').removeClass('hidden').html('Es wurde eine E-Mail mit einem Link zum Zurücksetzen des Passworts versendet, prüfen Sie Ihr Email-Postfach.');
          setTimeout(function () {
            window.location.href = './index.html';
          }, 5000);
        }).catch(function (err) {
          let errorMessage = 'Ein Fehler ist aufgetreten';
          if (err.responseJSON && err.responseJSON.error) {
            errorMessage = err.responseJSON.error;
          } else if (typeof err === 'string') {
            errorMessage = err;
          } else if (err.message) {
            errorMessage = err.message;
          } else if (err.error) {
            errorMessage = err.error;
          }
          $('#lgerror').removeClass('hidden').html(errorMessage);
          setTimeout(function () {
            $('#lgerror').addClass('hidden');
          }, 5000);
        });
    })
    // Create Password Button
    $('#createPasswordButton').on('click', function (e) {
      e.preventDefault()
      e.stopPropagation()
      if (!$('#termsAccepted').is(':checked')) {
        $('#lgerror').removeClass('hidden').html('Bitte akzeptieren Sie die Nutzungsbedingungen.');
        setTimeout(function () { $('#lgerror').addClass('hidden'); }, 5000);
        return;
      }
      // const errorCount = createPasswordValidator.checkAll();
      //   if (errorCount > 0) {
      //     return false;
      //   }
      const email = $('#email').val();
      const email2 = $('#email2').val();
      const pin = $('#pin').val();
      const passwd = $('#password').val();
      const passwd2 = $('#password2').val();
      const extratoken = getQueryParam('token');
      let type = $('#type').val();

      if (pin !== '' && type !== 1) {
        if (/^[A-Z0-9]{4}-[A-Z0-9]{4}-[A-Z0-9]{4}$/i.test(pin) && email !== '') {
          type = 1;
        } else if (extratoken !== '' && pin === '' && email === '') {
          type = 2;
        }
      }

      if(type === 0) {
        $('#lgerror').removeClass('hidden').html('Bitte füllen Sie alle Felder aus');
        setTimeout(function () {
          $('#lgerror').addClass('hidden');
        }, 5000);
        return;
      }

      Promise.resolve(createPassword(email, email2, pin, passwd, passwd2, extratoken, type))
        .then(function (result) {
          $('#termsDiv').hide();
          if(type === 1) {
            $('#pinDiv').hide();
            $('#emailDiv').hide();
            $('#email2Div').hide();
            $('#createPasswordSubline1').hide();
            $('#createPasswordSubline2').show();
            $('#createPasswordSubline3').hide();
            $('#passwordHintDivCreatePassword').hide();
          } else if(type === 2) {
            $('#passwordDiv').hide();
            $('#password2Div').hide();
            $('#passwordHintDivCreatePassword').hide();
            $('#createPasswordSubline1').show();
            $('#createPasswordSubline2').hide();
            $('#createPasswordSubline3').hide();
          } else {
            $('#pinDiv').hide();
            $('#emailDiv').hide();
            $('#email2Div').hide();
            $('#passwordDiv').hide();
            $('#password2Div').hide();
            $('#passwordHintDivCreatePassword').hide();
            $('#createPasswordSubline1').hide();
            $('#createPasswordSubline2').hide();
            $('#createPasswordSubline3').hide();
          }
          $('#createPasswordButton').hide();
          $('#lgsuccess').removeClass('hidden').html('Ihr Zugang wurde erfolgreich erstellt, prüfen Sie Ihr Email-Postfach.');
          setTimeout(function () {
            window.location.href = './index.html';
          }, 5000);
        })
        .catch(function (err) {
          let errorMessage = 'Ein Fehler ist aufgetreten';
          if(err.status === 422) {
            errorMessage = 'Das Passwort muss die Mindestanforderungen erfüllen.';
          } else if (err.responseJSON && err.responseJSON.error) {
            errorMessage = err.responseJSON.error;
          } else if (typeof err === 'string') {
            errorMessage = err;
          } else if (err.message) {
            errorMessage = err.message;
          } else if (err.error) {
            errorMessage = err.error;
          }
          $('#lgerror').removeClass('hidden').html(errorMessage);
          setTimeout(function () {
            $('#lgerror').addClass('hidden');
          }, 10000);
        });
    })
    // Save Password Button
    $('#savePasswordButton').on('click', function (e) {
      e.preventDefault()
      const extratoken = getQueryParam('token');
      const password = $('#password').val();
      const password2 = $('#password2').val();
      Promise.resolve(savePassword(extratoken, password, password2))
        .then(function (result) {
          $('#passwordDiv').hide();
          $('#password2Div').hide();
          $('#passwordHintDivResetPassword').hide();
          $('#savePasswordButton').hide();
          $('#lgsuccess').removeClass('hidden').html('Ihr Passwort wurde erfolgreich gespeichert, wir leiten Sie in Kürze zur Login-Seite weiter.');
          setTimeout(function() {
            window.location.href = './index.html';
          }, 5000);
        }).catch(function (err) {
          let errorMessage = 'Ein Fehler ist aufgetreten';
          if(err.status === 422) {
            errorMessage = 'Das Passwort muss die Mindestanforderungen erfüllen.';
          } else if (err.responseJSON && err.responseJSON.error) {
            errorMessage = err.responseJSON.error;
          } else if (typeof err === 'string') {
            errorMessage = err;
          } else if (err.message) {
            errorMessage = err.message;
          } else if (err.error) {
            errorMessage = err.error;
          }
          $('#lgerror').removeClass('hidden').html(errorMessage);
          setTimeout(function () {
            $('#lgerror').addClass('hidden');
          }, 5000);
        });
    })
    
  })


  function createPassword(email, email2, pin, passwd, passwd2, extratoken, type) {
    return $.ajax({
      method: 'POST',
      url: '/auth/create-password',
      data: {
        email: email,
        email2: email2,
        pin: pin,
        password: passwd,
        password2: passwd2,
        extratoken: extratoken,
        type: type,
        termsAccepted: true
      }
    }).then(function (result) {
        if (result.error !== undefined) {
            return Promise.reject(new Error(result.error +' 0'))
        }
        return result
    }).catch(function (err) {
        //console.log(err)
        return Promise.reject(err)
    })
  }
    
  function savePassword(extratoken, password, password2) {
    return $.ajax({
      method: 'POST',
      url: '/auth/save-password',
      data: {
        extratoken: extratoken,
        password: password,
        password2: password2
      }
    }).then(function (result) {
      if (result.error !== undefined) {
        return Promise.reject(new Error(result.error +' 0'))
      }
      return result
    }).catch(function (err) {
      return Promise.reject(err)
    })
  }

  function validatePin(pin) {
    return $.ajax({
      method: 'POST',
      url: '/auth/validate-pin',
      data: {
        pin: pin
      }
    }).then(function (result) {
      if (result.error !== undefined) {
        return Promise.reject(new Error(result.error +' 0'))
      }
      return result
    }).catch(function (err) {
      return Promise.reject(err)
    })
  }

  function resetPassword(email) {
    return $.ajax({
      method: 'POST',
      url: '/auth/reset-password',
      data: {
        email: email
      }
    }).then(function (result) {
      if (result.error !== undefined) {
        return Promise.reject(new Error(result.error +' 0'))
      }
      return result
    }).catch(function (err) {
      return Promise.reject(err)
    })
  }

  function handleTokenFields() {

      var $form = $('#createPasswordForm');
      if (!$form.length) return;

      var $subline1 = $('#createPasswordSubline1');
      var $subline2 = $('#createPasswordSubline2');
      var $subline3 = $('#createPasswordSubline3');
      var $pin = $form.find('#pinDiv').closest('.form-group');
      var $pw1 = $form.find('#passwordDiv').closest('.form-group');
      var $pw2 = $form.find('#password2Div').closest('.form-group');
      var $passwordHint = $form.find('#passwordHintDivCreatePassword').closest('.form-group');
      var $email = $form.find('#emailDiv').closest('.form-group');
      var $email2 = $form.find('#email2Div').closest('.form-group');
      var $createPasswordButton = $form.find('#createPasswordButton');
      var $validatePinButton = $form.find('#validatePinButton');

      $passwordHint.hide();

      const token = getQueryParam('token');

      let type = 0;
      
      if (!token) {

          $subline1.show();
          $subline2.hide();
          $subline3.hide();

          $pin.show();
          $validatePinButton.show();

          $email.hide();
          $email2.hide();

          $createPasswordButton.hide();

          $pw1.hide();
          $pw2.hide();
          $passwordHint.hide();

          return;
      }
      
      if (token !== '') {
          if (/^[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{4}$/i.test(token)) {
              type = 1;
          } else {
              type = 2;
          }
      }
      if (type ===  1) {

          $subline1.show();
          $subline2.hide();
          $subline3.hide();

          $pin.show();
          $pin.find('#pin').val(token);
          // Fill input with the token from URL
          $email.hide();
          $email2.hide();

          $pw1.hide();
          $pw2.hide();
          $passwordHint.addClass('hidden');

          $('#type').val(1);

          $validatePinButton.show();
          $createPasswordButton.hide();

      } else if (type ==  2) {

          $pin.hide();

          $email.hide();
          $email2.hide();

          $pw1.show();
          $pw2.show();
          $passwordHint.show();

          $('#type').val(2);

          $subline1.hide();
          $subline2.hide();
          $subline3.show();


          $validatePinButton.hide();
          $createPasswordButton.show();

      }else{

          $pin.hide();

          $email.hide();
          $email2.hide();

          $pw1.hide();
          $pw2.hide();
          $passwordHint.hide();

          $('#type').val(0);

          $subline1.hide();
          $subline2.hide();
          $subline3.hide();

          $validatePinButton.hide();
          $createPasswordButton.hide();

      }
  }
  function handleResetPasswordFields() {

      var $form = $('#resetPasswordForm');  
      var $subline1 = $('#resetPasswordSubline1');
      var $subline2 = $('#resetPasswordSubline2');
      var $pw1 = $form.find('#passwordDiv').closest('.form-group');
      var $pw2 = $form.find('#password2Div').closest('.form-group');
      var $passwordHint = $form.find('#passwordHintDivResetPassword').closest('.form-group');
      var $email = $form.find('#emailDiv').closest('.form-group');
      var $resetPasswordButton = $form.find('#resetPasswordButton');
      var $savePasswordButton = $form.find('#savePasswordButton');

      const token = getQueryParam('token');

      let type = 0;
      
      if (!token) {
          
          $email.show();

          $subline1.show();
          $subline2.hide();

          $resetPasswordButton.show();
          $savePasswordButton.hide();

          $pw1.hide();
          $pw2.hide();
          $passwordHint.hide();

          return;
      }
      
      if (token !== '') {

          $subline1.hide();
          $subline2.show();

          $pw1.show();
          $pw2.show();
          $passwordHint.show();

          $email.hide();

          $resetPasswordButton.hide();
          $savePasswordButton.show();
      }
  }

  function initPasswordToggle() {
    $(document).on('click', '.btn-password-toggle', function () {
      var $btn = $(this)
      var targetStr = $btn.data('target') || ''
      var $inputs = $(targetStr.split(',').map(function (s) { return s.trim() }).join(','))
      if (!$inputs.length) return
      var isVisible = $inputs.first().attr('type') === 'text'
      $inputs.attr('type', isVisible ? 'password' : 'text')
      $btn.toggleClass('is-visible', !isVisible)
        .attr('title', isVisible ? 'Passwort anzeigen' : 'Passwort verbergen')
        .attr('aria-label', isVisible ? 'Passwort anzeigen' : 'Passwort verbergen')
    })
  }

  function getQueryParam(name) {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(name);
  }


})();

